import React, { Component } from 'react';
import PublicRouters from './routes/router.jsx';
import { createBrowserHistory } from "history";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: { main: '#0847a7' }, // Purple and green play nicely together. #091635
    secondary: { main: '#4466f2' }, // This is just green.A700 as hex. #00acc1
    custom: {main: '#640178'} //2196F3
  },
  typography: {
    useNextVariants: true,
    fontFamily:[
      'Poppins',
    ].join(','),
  },
});

class App extends Component {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <PublicRouters history={createBrowserHistory()}/>
      </MuiThemeProvider>
    );
  }
}

export default App;
